<script>
import { v4 as uuidv4 } from 'uuid'
export default {
  name: 'text-input.generic',
  props: {
    value: { type: [String, Number] },
    id: { type: String, default: () => uuidv4() },
    label: { type: String },
    labelColsSm: { type: String, default: '12' },
    labelColsMd: { type: String },
    labelColsLg: { type: String },
    labelColsXl: { type: String },
    width: { type: [String, Number] },
    maxWidth: { type: [String, Number] },
    textAlign: { type: String, default: 'center' },
    append: { type: String },
    prepend: { type: String },
    onlyShowError: { type: Boolean, default: true },
    hideErrorMessages: { type: Boolean, default: false },
    hideValidationIcon: { type: Boolean, default: true },
    isValid: { type: Boolean, default: true },
    errorMessages: { type: Array }
  },
  methods: {
    onInputHandler (v) {
      if (isNaN(v)) {
        v = null
        this.number = null
      }
      this.$emit('input', v)
    }
  },
  data () {
    return {
      number: null
    }
  },
  watch: {
    value: {
      handler (v) {
        this.number = isNaN(v) ? 0 : v
      },
      immediate: true
    },
    number (v) {}
  }
}
</script>
<template>
  <b-form-group
    :label-for="id"
    :label-cols-sm="labelColsSm"
    :label-cols-md="labelColsMd"
    :label-cols-lg="labelColsLg"
    :label-cols-xl="labelColsXl"
    class="d-flex align-items-center"
    :class="{
      'is-invalid': !isValid,
      'is-valid': isValid && !onlyShowError
    }"
  >
    <template v-slot:label>
      <div class="d-flex align-items-center pointer" v-if="label">
        {{ label }}
      </div>
    </template>
    <b-input-group :prepend="prepend" :append="append">
      <slot name="prepend"></slot>
      <b-form-input
        :id="id"
        v-bind="$attrs"
        v-on="$listeners"
        v-on:focus="$event.target.select()"
        v-on:input="onInputHandler"
        :value="number"
        :style="{ maxWidth, width, textAlign }"
        :class="{
          'is-invalid': !isValid,
          'is-valid': isValid && !onlyShowError,
          'hide-icon': hideValidationIcon
        }"
        :aria-describedby="`err_${id}`"
        required
        trim
      ></b-form-input>
      <slot name="append"></slot>
    </b-input-group>
    <b-form-invalid-feedback
      :id="`err_${id}`"
      v-if="!isValid && !hideErrorMessages"
    >
      <slot name="errors">
        <template v-if="!errorMessages">Fix this field</template>
        <template v-else>
          <span
            class="d-block"
            v-for="(err, idx) in errorMessages"
            :key="`err_${id}_${idx}`"
            >{{ err }}</span
          >
        </template>
      </slot>
    </b-form-invalid-feedback>
  </b-form-group>
</template>
